"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var ConnectorIcon = function ConnectorIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#5C5C5C",
    d: "M16.334 13.125a4.535 4.535 0 0 0 0-2.25h5.011a.23.23 0 0 1 .23.2 7.405 7.405 0 0 1 0 1.85.23.23 0 0 1-.23.2h-5.011z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#2E2E2E",
    d: "M12 15.375a3.375 3.375 0 1 0 0-6.75 3.375 3.375 0 0 0 0 6.75zm0-2.25a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#939393",
    d: "M12.001 3.375a8.627 8.627 0 0 0-7.94 5.25H3.05a.276.276 0 0 0-.262.185 9.75 9.75 0 0 0 0 6.38.276.276 0 0 0 .262.185h1.01a8.627 8.627 0 0 0 14.196 2.563c.2-.211.14-.55-.112-.695l-.864-.499c-.376-.217-.848-.141-1.18.138a6.375 6.375 0 1 1 0-9.765c.332.28.805.356 1.18.139l.864-.5a.447.447 0 0 0 .112-.694A8.6 8.6 0 0 0 12 3.375z"
  }));
};
ConnectorIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#MuleConnectorAsset',
    assetType: 'MuleConnector'
  },
  owner: {
    gusTeam: 'MS Connectivity Infrastructure Team',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00AH000000in0hYAA/view'
  },
  name: 'Connector',
  publication: {
    inferredBy: [{
      classifiers: ['mule-plugin']
    }],
    files: [{
      id: 'module',
      classifier: 'mule-plugin',
      packaging: 'jar'
    }],
    minimumInputSets: [{
      files: ['module']
    }],
    extensionPoints: [{
      name: 'legacyMetadataExtraction',
      timeout: 60
    }]
  },
  portal: {
    icon: ConnectorIcon,
    color: '#178bea' // navy3
  },
  keywords: ['connector', 'extension']
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map